<template>
  <ElDialog v-model="isShow" :width="getWidth()" append-to-body :show-close="false" class="logout-dialog" top="35vh">
    <img class="close" src="@/assets/images/close.png" alt="close" @click="isShow = false" />

    <div class="top">
      <div>信息</div>
      <div>information</div>
    </div>

    <div class="message">
      <div>确定退出系统吗？</div>
      <div>Are you sure you want to log out?</div>
    </div>

    <div class="form-content">
      <ElButton class="btn" :loading="loading" @click="confirm">确定 Sure</ElButton>
      <ElButton class="btn-cancel" @click="isShow = false">取消 Cancel</ElButton>
    </div>
  </ElDialog>
</template>

<script setup lang="ts">
import { ref, defineExpose } from 'vue'
import { logout } from '@/api'
import { useUserStore } from '@/stores/user'
import { ElMessage } from 'element-plus'
import { useAppStore } from '@/stores/app'

const user = useUserStore()
const appStore = useAppStore()

const isShow = ref(false)
const loading = ref(false)
const open = () => {
  isShow.value = true
}

const getWidth = () => {
  return appStore.isMobile ? '5.96rem' : '530px'
}

const logoutBE = async () => {
  try {
    loading.value = true
    const { code, message } = await logout()

    if (code !== 200) {
      ElMessage.error(message)
      return
    }
    ElMessage.success('登出成功 Logout Successful')

    user.setIsLogin(false)
    isShow.value = false
  } catch {
  } finally {
    loading.value = false
  }
}

const confirm = async () => {
  logoutBE()
}

defineExpose({ open })
</script>

<style lang="less" scoped>
.top {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
}

.close {
  width: 28px;
  height: 28px;
  position: absolute;
  top: 13px;
  right: 17px;
  cursor: pointer;
}

.form-content {
  padding: 38px 0 50px;
  display: flex;
  justify-content: center;
}

.top {
  display: flex;
  justify-content: center;
  font-size: 20px;
  font-weight: 500;
  color: #333;
}

.btn {
  width: 150px;
  height: 42px;
  background:
    radial-gradient(139.54% 111.46% at 53.7% -11.46%, #fadec5 0%, #c5a68b 61.54%, #dbbfa7 100%),
    radial-gradient(72.9% 34.37% at 50% 0%, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0) 79.06%);
  background-blend-mode: overlay;
  box-shadow:
    0px 1px 2px 0px rgba(38, 26, 23, 0.3),
    inset 0px 0px 4.8px 0px rgba(255, 255, 255, 0.9);
  border: 1px solid transparent;
  border-image-slice: 1;
  border-radius: 40px;
  font-size: 20px;
  color: #fff;
  font-weight: 500;
}

.btn-cancel {
  width: 150px;
  height: 42px;
  border-radius: 40px;
  border-color: #c3a082;
  color: #c3a082;
}

.message {
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #333;
}
</style>
